import "./contact.css";

export const Contact = () => {
  return (
    <section className="contact">
      <h2>Contato</h2>
      <div className="formContainer">
        <form
          action="https://formsubmit.co/josephmatheus@hotmail.com"
          method="post"
        >
          <input
            type="hidden"
            name="_next"
            value="https://josephmatheus-portfolio.vercel.app/success.html"
          />
          <input type="hidden" name="_captcha" value="false" />
          <input type="text" name="name" placeholder="Nome:" required />
          <input type="text" name="email" placeholder="Email:" required />
          <input type="text" name="subject" placeholder="Assunto:" required />
          <textarea
            name="message"
            id=""
            rows="5"
            placeholder="Mensagem:"
            required
          ></textarea>
          <button type="submit">Enviar</button>
        </form>
      </div>
    </section>
  );
};
